module.exports = __webpack_public_path__ + "assets/img/template-introduce-list-4.0ee8f5a6.png";